import React, { useContext } from 'react';
import { GlobalContext } from '../../utilities/GlobalContext';

function NavStyles () {
    //#region Params
    let isMobile = useContext(GlobalContext).isMobile;
    let size = useContext(GlobalContext).size;
    //#endregion

    //#region Style vars
    //#endregion

    //#region seting vars based off params
    
    //#endregion

    return({
        outerStyle: () => {
            return({
                width: '100vw',
                height: '100vh',
                backgroundSize: 'fill',
                backgroundColor: 'black',
                position: 'fixed',
                zIndex: '-3',
                display: 'flex',
                margin: 0,
                padding: 0,
            });
        },
        backgroundImage: (backgroundImage) => {
            return({
                width: '100%',
                height: '100%',
                position: 'fixed',
                objectFit: 'cover',
                backgroundColor: 'black',
                backgroundSize: 'cover',
                display: 'flex',
                zIndex: -1,
                margin: '-1px'
            });
        },
        contentContainer: () => {
            let margin = '15rem';
            if(size === 'md' || size === 'sm'){
                margin = '5rem';
            }
            if(isMobile){
                margin = '2rem';
            }
            return({
                width: '100%',
                margin: 'auto',
                color: 'white',
                fontSize: '4rem',
                display: 'flex',
                flexDirection: 'collumn',
                marginLeft: margin,
                marginRight: margin
             });
        },
        title: () => {
            return({
                margin: 0,
                color: 'white',
                fontSize: '5rem'
            });
        }
    });
}

export default NavStyles;